import React, { useState } from 'react'

import { useMediaQuery } from 'react-responsive'
import { mediaQueryForMobile } from '../HomePage/HomePage'
import { BaseModal } from '../../components/BaseModal'

import './BanksGridRebatesModal.scss'

export const BanksGridRebatesModal = (props) => {
    const {
        open,
        onClose,
        setIsOpen,
        mode = 'lease',
        vehicle = '2026 Jeep Grand Wagoneer L 4D WAGON 4X2 (29E)',
        onApply,
        ...customProps
    } = props

    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const [rebatesOpen, setRebatesOpen] = useState(true)
    const [selectedRebates, setSelectedRebates] = useState(new Set())

    const banks = [
        'U.S. Bank',
        'Stellantis Financial Services',
        'Ally Financial',
        'RIZE C.U.',
        'KeyPoint Credit Union',
        'Westlake Financial Services',
    ]

    const quotes = [
        { term: 24, values: ['$1,500', '$1,615', '$1,786', '$1,900', '$1,907', '$1,968'] },
        { term: 27, values: ['$1,427', '$1,460', '$1,665', '', '', ''] },
        { term: 30, values: ['', '$1,637', '$1,625', '$1,632', '$1,693', ''] },
        { term: 33, values: ['', '', '$1,591', '', '', ''] },
        { term: 36, values: ['$1,178', '$1,317', '$1,418', '$1,421', '$1,428', '$1,488'] },
        { term: 39, values: ['$1,169', '$1,210', '$1,371', '$1,333', '$1,340', '$1,399'] },
        { term: 42, values: ['$1,143', '$1,313', '$1,394', '$1,378', '$1,396', '$1,442'] },
        { term: 45, values: ['', '', '$1,382', '', '', ''] },
        { term: 48, values: ['$1,143', '$1,230', '$1,345', '$1,328', '$1,345', '$1,389'] },
    ]

    const rebates = [
        { id: 'other-cash', name: 'Total Other Cash', summary: true, values: ['$0.00', '$0.00', '$0.00'] },
        { id: 'dealer-cash', name: 'Total Dealer Cash', summary: true, values: ['$0.00', '$0.00', '$0.00'] },
        { id: 'buick-gmc-consumer', name: 'Buick & GMC Consumer Cash', hasDoc: true, values: ['N/A', 'N/A', '$1,750.00'] },
        { id: 'gm-bonus', name: 'GM Bonus Cash', hasDoc: true, values: ['N/A', 'N/A', '$0.00'] },
        { id: 'accessibility', name: 'Accessibility Adaptive Equipment', hasDoc: true, values: ['$1,500.00', '$1,500.00', '$1,500.00'] },
        { id: 'uaw-gm', name: 'Active UAW-GM Hourly Employee Vehicle Allowance', hasDoc: true, values: ['$1,500.00', '$1,500.00', '$1,500.00'] },
        { id: 'lease-loyalty', name: 'Buick & GMC Lease Loyalty', hasDoc: true, values: ['$2,250.00', '$2,250.00', 'N/A'] },
        { id: 'employee-appreciation', name: 'GM Employee Appreciation Certificate', hasDoc: true, values: ['$1,500.00', '$1,500.00', '$1,500.00'] },
        { id: 'ev-tour', name: 'GM EV Tour Experience Discount', hasDoc: true, values: ['$0.00', '$0.00', '$0.00'] },
        { id: 'first-responder', name: 'GM First Responder Cash Allowance', hasDoc: true, values: ['$500.00', '$500.00', '$500.00'] },
        { id: 'insurance-replacement', name: 'GM Insurance Replacement Vehicle Targeted Private Offer', hasDoc: true, values: ['$1,500.00', '$1,500.00', '$1,500.00'] },
        { id: 'lease-conquest', name: 'GM Lease Loyalty & Lease Conquest Program', hasDoc: true, values: ['$1,500.00', '$1,500.00', 'N/A'] },
    ]

    const toggleRebate = (id) => {
        const next = new Set(selectedRebates)
        if (next.has(id)) {
            next.delete(id)
        } else {
            next.add(id)
        }
        setSelectedRebates(next)
    }

    const handleApply = () => {
        const selectedRows = rebates.filter((r) => selectedRebates.has(r.id))
        if (onApply) {
            onApply(selectedRows)
        }
        setIsOpen(null)
    }

    const handleCancel = () => {
        setIsOpen(null)
    }

    const tagText = mode === 'finance' ? 'FINANCE' : 'LEASE'
    const tagColor = mode === 'finance' ? '#3db89a' : '#4A90E2'
    const tagBg = mode === 'finance' ? 'rgba(61,184,154,0.15)' : 'rgba(74,144,226,0.15)'

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#1a1d27',
        boxShadow: 24,
        zIndex: '1400',
        outline: 'none',
        borderRadius: '8px',
        padding: isTabletOrMobile ? '10px' : '20px',
        minWidth: isTabletOrMobile ? '' : '1100px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        overflow: 'auto',
    }

    const ChevronIcon = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
        </svg>
    )

    const DocIcon = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
            <polyline points="14 2 14 8 20 8" />
        </svg>
    )

    const SortIcon = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
        </svg>
    )

    return (
        <BaseModal isOpen={open} onClose={onClose} setIsOpen={setIsOpen} style={style}>
            <div className="banks-grid-rebates-modal" {...customProps}>
                <div className="container">
                    <div className="topbar">
                        <span className="topbar-title">
                            Quotes for <strong>{vehicle}</strong>
                        </span>
                        <span className="lease-tag" style={{ color: tagColor, background: tagBg }}>
                            {tagText}
                        </span>
                        <div className="topbar-right">
                            <button className="sort-btn">
                                Sort By Lender
                                <SortIcon />
                            </button>
                        </div>
                    </div>
                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>Term</th>
                                    {banks.map((bank) => (
                                        <th key={bank}>{bank}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {quotes.map((row) => (
                                    <tr key={row.term}>
                                        <td>{row.term}</td>
                                        {row.values.map((val, idx) => (
                                            <td key={idx}>
                                                {val ? (
                                                    <span
                                                        className={`price-chip ${row.term === 36 && idx === 0 ? 'best' : ''}`}
                                                    >
                                                        {val}
                                                    </span>
                                                ) : null}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="container" style={{ marginTop: '10px' }}>
                    <div className="rebates-panel" style={{ borderTop: 'none' }}>
                        <div className="rebates-header" onClick={() => setRebatesOpen(!rebatesOpen)}>
                            <span className="rebates-title">Rebates</span>
                            <div className={`chevron ${rebatesOpen ? 'open' : ''}`}>
                                <ChevronIcon />
                            </div>
                        </div>
                        <div className={`rebates-body ${rebatesOpen ? 'open' : ''}`}>
                            <table className="rebates-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '44px' }}></th>
                                        <th className="th-name">Rebate Program</th>
                                        <th style={{ width: '36px' }}></th>
                                        <th>GM Financial</th>
                                        <th>GMF Std</th>
                                        <th>Other Banks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rebates.map((rebate) => (
                                        <tr key={rebate.id} className={rebate.summary ? 'summary-row' : ''}>
                                            <td className="td-check">
                                                {!rebate.summary && (
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedRebates.has(rebate.id)}
                                                        onChange={() => toggleRebate(rebate.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="td-name">{rebate.name}</td>
                                            <td className="td-doc">{rebate.hasDoc && <DocIcon />}</td>
                                            {rebate.values.map((val, idx) => (
                                                <td key={idx} className={val === 'N/A' ? 'na' : ''}>
                                                    {val}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="rebates-actions">
                                <button className="btn-cancel" onClick={handleCancel}>
                                    Cancel
                                </button>
                                <button className="btn-apply" onClick={handleApply}>
                                    Apply Selected Rebates
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BaseModal>
    )
}
